import moment from "moment";

const validateNumberRange = (number, minimum, maximum) => {
    if (number === undefined) {
        return false
    }

    return number >= minimum && number <= maximum;
}

export const isNumberBetweenRange = validateNumberRange

export const getNumberWithinRangeElseDefault = (number, defaultNumber, minimum, maximum) => {
    if (validateNumberRange(number, minimum, maximum) === true) {
        return Number(number)
    }

    return defaultNumber
}

export const areDatesValid = (start, end) => {
    if (!start || !end) {
        return false;
    }

    const startDate = moment(start)
    const endDate = moment(end)

    if (startDate.isValid() === false || endDate.isValid() === false) {
        return false
    }

    return startDate.isSameOrAfter(moment(), 'day') && endDate.isAfter(startDate, 'day')
}

export const areFeaturesValid = (featuresString) => {
    return featuresString !== undefined;
}

export const isNumberOfGuestsValid = (numberOfAdults, numberOfChildren, numberOfInfants, maximumOccupants) => {
    return (numberOfAdults + numberOfChildren + numberOfInfants) <= maximumOccupants;
}

export const isGroupValid = (group) => {
    return group !== undefined && group !== '';
}
